module.exports = __webpack_public_path__ + "img/bf-2022-banner.16d55037.jpg";